// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-m_ff","advertDetailHeaderPrice__value":"c-m_fg","advertDetailHeaderPrice__label":"c-m_fh"};